// Demo data of the « experience » role (a read-only showcase account): the
// agents pages show these and simulate their writes in memory, as before.
const now = new Date().toISOString();

export const DEMO_TOOLS = [
  { id: 'exp_tool_1', name: 'get_tracking_info', type: 'function', function: { name: 'get_tracking_info', description: 'Retrieves tracking information for an order.' } },
  { id: 'exp_tool_2', name: 'Retrieve_customer_order_by_ID', type: 'function', function: { name: 'Retrieve_customer_order_by_ID', description: 'Fetches order details using the order ID.' } },
  { id: 'exp_tool_3', name: 'retrieve_knowledge', type: 'function', function: { name: 'retrieve_knowledge', description: 'Searches the knowledge base for answers.' } },
  { id: 'exp_tool_4', name: 'assign_to_employee', type: 'function', function: { name: 'assign_to_employee', description: 'Assigns the ticket to a human agent.' } },
];

export const DEMO_AGENTS = [
  {
    _id: 'exp_asst_1', name: 'Customer Service Pro (Demo)', is_running: true, created_at: now, updated_at: now,
    prompt: 'You are a friendly and efficient customer service AI. Help users with their inquiries about orders, returns, and product information. Prioritize quick and accurate solutions.',
    selected_tool_ids: ['exp_tool_1', 'exp_tool_2'], associated_email: 'experience_user@gmail.com', associated_channels: { WhatsApp: true },
  },
  {
    _id: 'exp_asst_2', name: 'Technical Support Bot (Demo)', is_running: false, created_at: now, updated_at: now,
    prompt: 'Assist users with technical issues, troubleshooting, and setup guides. Be patient and provide clear, step-by-step instructions.',
    selected_tool_ids: ['exp_tool_3'], associated_channels: { Messenger: true },
  },
  {
    _id: 'exp_asst_3', name: 'Sales Advisor (Demo)', is_running: false, created_at: now, updated_at: now,
    prompt: 'Guide customers through our product catalog, offer recommendations, and help them complete purchases.',
    selected_tool_ids: [], associated_email: 'experience_user_outlook@example.com',
  },
];

export const DEMO_EMAILS = { gmail_email: 'experience_user@gmail.com', outlook_emails: ['experience_user_outlook@example.com'] };

export const DEMO_CHANNELS = { WhatsApp: true, Messenger: true, Website: true, Instagram: false };
